import { Star, User } from 'lucide-react';
import { WeddingReview } from '../../types';

interface ReviewCardProps {
    review: WeddingReview;
}

export default function ReviewCard({ review }: ReviewCardProps) {
    return (
        <div className="bg-white dark:bg-gray-800 p-5 rounded-xl border border-gray-100 dark:border-gray-700 shadow-sm">
            <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                    <div className="w-10 h-10 rounded-full bg-rose-100 dark:bg-rose-900/30 flex items-center justify-center text-rose-600 dark:text-rose-400 overflow-hidden">
                        {review.user?.avatar_url ? (
                            <img src={review.user.avatar_url} alt={review.user.full_name} className="w-full h-full object-cover" />
                        ) : (
                            <User size={20} />
                        )}
                    </div>
                    <div>
                        <h4 className="font-semibold text-gray-900 dark:text-white text-sm">
                            {review.user?.full_name || 'Anonymous'}
                        </h4>
                        <span className="text-xs text-gray-500 dark:text-gray-400">
                            {new Date(review.created_at).toLocaleDateString(undefined, {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            })}
                        </span>
                    </div>
                </div>
                <div className="flex text-amber-400">
                    {[...Array(5)].map((_, i) => (
                        <Star
                            key={i}
                            size={14}
                            className={i < review.rating ? 'fill-current' : 'text-gray-300 dark:text-gray-600'}
                        />
                    ))}
                </div>
            </div>
            <p className="text-gray-600 dark:text-gray-300 text-sm leading-relaxed">
                {review.content}
            </p>
        </div>
    );
}
